import React, {useEffect, useRef, useState} from 'react';

// 이미지 임포트 (실제 이미지 경로로 변경 필요)
import stores from '../../../assets/images/about/section_02_subsection_04_item_01.png';

const AboutSubSection0204: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        // 섹션이 화면에 보일 때만 애니메이션 적용
        if (entry.isIntersecting) {
          setIsVisible(true);
        } else {
          // 섹션이 화면에서 벗어났을 때
          setIsVisible(false);
        }
      },
      {
        threshold: window.innerWidth <= 1024 ? 0.08 : 0.2, // 섹션이 20% 이상 보일 때 트리거 // 섹션이 20% 이상 보일 때 트리거
        rootMargin: '-50px' // 뷰포트 경계에서 50px 안쪽에서 트리거
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <div ref={sectionRef} className={`container text-black pt-[105px] pb-[70px] transition-all duration-[1500ms] [transition-timing-function:cubic-bezier(0.4,0,0.2,1)] ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
      <div className="hidden lg:block mx-auto">
        {/* 메인 콘텐츠 - 왼쪽 이미지, 오른쪽 텍스트 */}
        <div className="flex flex-row items-center justify-between lg:gap-8 xl:gap-16 2xl:gap-32">
          {/* 왼쪽: 이미지 */}
          <div className="w-1/2 2xl:w-2/5">
            <img
              src={stores}
              alt="오프라인 스토어 이미지 1"
              className="w-full max-w-[676px] object-cover rounded-[5px]"
            />
          </div>

          {/* 오른쪽: 텍스트 정보 */}
          <div className="w-1/2 2xl:w-2/5">
            {/* 섹션 제목 */}
            <p className="text-xl font-semibold mb-[72px]">
              Distribution Channels
            </p>
            <p className="text-40 leading-[1.4] font-bold mb-[72px]">
              국내 대표 유통 채널 다각화<br/>
              브랜드 노출과 구매 접점을 동시에
            </p>
            <p className="text-xl font-normal leading-[1.6]">
              네이버, 쿠팡 등 국내 대표 커머스와 무신사, 면세점 등 오프라인 유통 채널을 확보했습니다.<br/>
              탄탄한 유통망을 기반으로 브랜드 노출과 고객 구매 접점을 효과적으로 확장하고 있습니다.
            </p>
          </div>
        </div>
      </div>
      <div className="lg:hidden mx-auto">
        {/* 메인 콘텐츠 - 왼쪽 텍스트, 오른쪽 이미지 */}
        <div className="flex flex-col items-center justify-center">
          {/* 왼쪽: 통계 정보 */}
          <p className="text-2xl md:text-4xl font-semibold mb-[30px] md:mb-[50px]">
            Distribution Channels
          </p>
          <span className="text-4xl md:text-6xl leading-[1.4] font-bold md:mb-4">
              국내 대표 유통 채널 다각화
          </span>
          <span className="text-4xl md:text-6xl leading-[1.4] font-bold">
              브랜드 노출과 구매 접점을 동시에
          </span>

          <img
            src={stores}
            alt="폰뷰 앱 화면"
            className="w-5/6 h-auto py-12 md:py-20"
          />
          
          <p className="text-center font-normal text-2xl md:text-4xl leading-[1.6] md:mb-2">
            네이버, 쿠팡 등 국내 대표 커머스와 무신사, 면세점 등</p>
          <p className="text-center font-normal text-2xl md:text-4xl leading-[1.6] md:mb-2">
            오프라인 유통 채널을 확보했습니다.</p>
          <p className="text-center font-normal text-2xl md:text-4xl leading-[1.6] md:mb-2">
            탄탄한 유통망을 기반으로 브랜드 노출과</p>
          <p className="text-center font-normal text-2xl md:text-4xl leading-[1.6] md:mb-2">
            고객 구매 접점을 효과적으로 확장하고 있습니다.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutSubSection0204;